// PRODUCTION — flow editor step config shared constants
import type { BasicSelectOption } from 'src/components/shared/form/BasicSelect'
import { StepApprovalType } from 'src/interfaces/onboardingTemplate'

export const APPROVAL_TYPE_OPTIONS: BasicSelectOption[] = [
  { label: 'Auto Approval', value: StepApprovalType.AutoApproval },
  { label: 'Customer Approval', value: StepApprovalType.CustomerApproval },
  { label: 'Internal Approval', value: StepApprovalType.InternalApproval },
  { label: 'Internal then Customer', value: StepApprovalType.InternalThenCustomerApproval },
  { label: 'Customer then Internal', value: StepApprovalType.CustomerThenInternalApproval },
]

export const POLICY_PRODUCT_OPTIONS: BasicSelectOption[] = [
  { label: 'GigSafe Basic', value: 'GigSafe Basic' },
  { label: 'GigSafe Plus', value: 'GigSafe Plus' },
  { label: 'GigSafe Pro', value: 'GigSafe Pro' },
  { label: 'Commercial Auto', value: 'Commercial Auto' },
  { label: 'Occupational Accident', value: 'Occupational Accident' },
]
